import { createContext } from 'react';

const RecommendationsContext = createContext();

export default RecommendationsContext;
